import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
} from "react-icons/fa";

import "swiper/css";


const ReviewsSection = () => {

const reviews = [

  {
    name: "Mrs. Neha Deshmukh",
    rating: 5,
    text:
      "Booked a Sai Shirdi cab for Sai Baba Darshan with my family. The driver arrived on time and the entire journey was smooth, safe and comfortable.",
  },

  {
    name: "Mr. Suresh Pawar",
    rating: 5,
    text:
      "Excellent Shirdi cab service. The booking process was easy, the driver was polite and the vehicle was clean and comfortable throughout our trip.",
  },

  {
    name: "Mrs. Anjali Joshi",
    rating: 5,
    text:
      "We booked a cab for our Shirdi pilgrimage trip and had a very comfortable experience. The driver was experienced and drove safely throughout the journey.",
  },

  {
    name: "Mr. Mahesh Kulkarni",
    rating: 5,
    text:
      "Booked an Innova Crysta for our family Sai Baba Darshan trip. The car was spacious and clean, and the driver made our Shirdi journey completely hassle-free.",
  },

  {
    name: "Mrs. Pooja Patil",
    rating: 4.5,
    text:
      "Very reliable Sai Shirdi cab service. We booked a round-trip taxi and everything was well managed. The pickup and return journey were both comfortable.",
  },

  {
    name: "Mr. Vijay Shinde",
    rating: 5,
    text:
      "Had a great experience with Sai Shirdi Cabs. Safe driving, comfortable vehicle and professional service. Highly recommended for Shirdi Darshan trips.",
  },

];



  const getInitials = (name) => {

    return name
      .replace("Mr.", "")
      .replace("Mrs.", "")
      .replace("Miss.", "")
      .trim()
      .split(" ")
      .map((word) => word[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();

  };


  const renderStars = (rating) => {

    let stars = [];

    for (let i = 1; i <= 5; i++) {

      if (i <= rating) {

        stars.push(
          <FaStar
            key={i}
            className="star-icon"
          />
        );

      }

      else if (i - 0.5 === rating) {

        stars.push(
          <FaStarHalfAlt
            key={i}
            className="star-icon"
          />
        );

      }

      else {

        stars.push(
          <FaRegStar
            key={i}
            className="star-icon"
          />
        );

      }

    }

    return stars;

  };


  return (

    <section className="reviews-section p-0 py-3">

      <div className="reviews-container">

        <div className="reviews-header">

          <span className="text-white">
            Customer Reviews
          </span>

          <h2 className="text-white">
            Happy devotees trust Sai Shirdi Cabs for safe,
            comfortable and reliable Shirdi pilgrimage trips,
            Sai Baba Darshan, family travel, one-way cabs
            and round-trip taxi services.
          </h2>

        </div>


        <Swiper

          modules={[Autoplay]}

          spaceBetween={25}

          slidesPerView={3}

          loop={true}

          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}

          breakpoints={{

            0: {
              slidesPerView: 1,
            },

            768: {
              slidesPerView: 2,
            },

            1024: {
              slidesPerView: 3,
            }

          }}

          className="reviews-slider"

        >

          {
            reviews.map((review, index) => (

              <SwiperSlide key={index}>

                <div className="review-card">

                  <div className="review-stars">

                    {
                      renderStars(review.rating)
                    }

                  </div>


                  <p className="text-white">
                    "{review.text}"
                  </p>


                  <div className="customer-info">

                    <div className="profile-circle">

                      {
                        getInitials(review.name)
                      }

                    </div>


                    <div>

                      <h4>
                        {review.name}
                      </h4>

                      <span>
                        Verified Customer
                      </span>

                    </div>

                  </div>

                </div>

              </SwiperSlide>

            ))
          }

        </Swiper>

      </div>

    </section>

  );

};


export default ReviewsSection;
